import { IconButton, Typography } from '@mui/material'
import { AddOutlined } from '@mui/icons-material'

export default function FormikAddBtnIcon({ isDisabled, onClick }) {
  return (
    <IconButton disabled={isDisabled} aria-label='add' onClick={onClick}>
      <AddOutlined
        color={isDisabled ? 'disabled' : 'secondary'}
        fontSize='large'
      />
      <Typography color={isDisabled ? 'textSecondary' : 'secondary'}>
        增加
      </Typography>
    </IconButton>
  )
}
